import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const CardsIcon = observer('CardsIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            fill='none'
            viewBox='0 0 24 24'
            className={className}
            onClick={onClick}
        >
            <path
                fill='#39B54A'
                d='M18.744 12.431c-.288-.682-.92-1.203-1.688-1.383-.737-.145-1.5.04-2.062.504a2.482 2.482 0 0 0-2.056-.504c-.769.185-1.387.7-1.681 1.383a2.398 2.398 0 0 0 .1 2.339c.775 1.163 3.237 3.056 3.35 3.131.087.07.193.104.3.098a.537.537 0 0 0 .312-.098c.1-.075 2.568-1.968 3.33-3.137a2.387 2.387 0 0 0 .088-2.332h.007Zm-.92 1.876c-.53.816-2.136 2.13-2.818 2.68-.675-.539-2.28-1.853-2.812-2.68a1.587 1.587 0 0 1-.037-1.523c.162-.41.53-.74.993-.868a1.61 1.61 0 0 1 .288-.023 1.64 1.64 0 0 1 1.181.562.505.505 0 0 0 .781 0c.344-.423.906-.62 1.469-.539.456.128.825.452.993.868a1.57 1.57 0 0 1-.037 1.523Z'
            />
            <path
                fill='#FFFFFF'
                d='M19.035 18.02v1.48a.473.473 0 1 1-.946 0v-1.48c0-.269.215-.481.473-.481s.473.219.473.481ZM11.795 9.685v-1.48a.481.481 0 0 0-.473-.482.477.477 0 0 0-.472.481v1.481c0 .263.208.481.472.481a.476.476 0 0 0 .332-.143.493.493 0 0 0 .141-.338Z'
            />
            <path
                fill='#FFFFFF'
                fillRule='evenodd'
                d='M20.41 6.305a1.96 1.96 0 0 0-1.424-.606h-2.684l-1.51-2.65a2.057 2.057 0 0 0-1.24-.968A1.772 1.772 0 0 0 13.01 2c-.35 0-.7.094-1 .275L5.027 6.38c-.466.269-.81.718-.958 1.256a2.097 2.097 0 0 0 .203 1.574l2.168 3.824s.27.55.829.212c.479-.293.19-.812.19-.812L5.298 8.617a.896.896 0 0 1 .314-1.194l6.975-4.098a.778.778 0 0 1 .43-.113c.301 0 .59.169.743.437l1.16 2.05h-4.058c-1.112 0-2.02.925-2.02 2.055v5.667l-.013-.025v3.874l.025.025v2.65c0 .543.209 1.062.595 1.449.369.387.885.606 1.419.606h8.112a1.96 1.96 0 0 0 1.424-.606 2.04 2.04 0 0 0 .596-1.45V7.754c0-.55-.215-1.062-.596-1.45h.006Zm-.595 13.64a.876.876 0 0 1-.246.6.835.835 0 0 1-.59.25h-8.111a.836.836 0 0 1-.823-.844V7.76c0-.469.369-.844.823-.844h8.112c.22 0 .436.094.59.25a.876.876 0 0 1 .245.6v12.177Z'
                clipRule='evenodd'
            />
        </SvgElement>
    );
});
